// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3xYEj","savePackageButton":"ClientWallet_savePackageButton__23x76"};